import { Component, input, output } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { SelectButton, type SelectButtonChangeEvent } from "primeng/selectbutton";
import { NewUiWrapperReadonlyComponent } from "../../form/wrapper-readonly/new-ui-wrapper-readonly.component";
import { NewUiWrapperWritableComponent } from "../../form/wrapper-writable/new-ui-wrapper-writable.component";
import { NewUiFormElementMapModule } from "../../from-element-map/new-ui-form-element-map.module";
import { TestIdDirective } from "../../test-id/test-id.directive";
import { NewUiLabelPipe } from "../label/new-ui-label.pipe";
import { injectNgControl } from "../util";

@Component({
  selector: "new-ui-selectbutton",
  templateUrl: "./new-ui-selectbutton.component.html",
  imports: [
    ReactiveFormsModule,
    SelectButton,
    NewUiWrapperReadonlyComponent,
    NewUiWrapperWritableComponent,
    NewUiFormElementMapModule,
    TestIdDirective,
    NewUiLabelPipe,
  ],
})
export class NewUiSelectbuttonComponent {
  readonly ngControl = injectNgControl();

  readonly options = input.required<unknown[]>();
  readonly optionLabel = input<string>();
  readonly optionValue = input<string>();
  readonly label = input.required<string>();
  readonly readonly = input<boolean>();
  readonly required = input<boolean>();
  readonly allowEmpty = input<boolean>(true);
  readonly multiple = input<boolean>(false);

  readonly changed = output<SelectButtonChangeEvent>();
}
